function DateSelector({ selectDate }) {
    return (
        <input
            type="date"
            onChange={e => {
                selectDate(Number(new Date(e.target.value))/1000);
            }}
        />
    )
}

export default DateSelector;